import React from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
`
const Sections = styled(Wrapper)`
  margin-top: 80px;
  margin-bottom: 80px;
  ${media.max.md`
    margin: 30px 20px 30px 20px;
  `}
`
const GreyWrap = styled.div`
  overflow: hidden;
  background-color: #f3f7f9;
`
export function Section(props: any) {
  const { children } = props
  return <Sections>{children}</Sections>
}

export function GreySection(props: any) {
  const { children } = props
  return (
    <GreyWrap>
      <Sections>{children}</Sections>
    </GreyWrap>
  )
}
